import {
  container,
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  transition,
  boxShadow,
  drawerWidth,
  headerColor
} from "./material-kit-react.js"
import {colors, modernColors} from '../components/Theme/WebTheme';

const headerStyle = {
  appBar: {
    display: "flex",
    border: "0",
    borderRadius: "0",
    padding: "0",
    margin: "0",
    color: modernColors.textPrimary,
    width: "100%",
    backgroundColor: modernColors.appBar,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    position: "relative",
    zIndex: 1200
  },
  absolute: {
    position: "absolute",
    zIndex: 1200
  },
  fixed: {
    position: "fixed",
    zIndex: 1200
  },
  container: {
    ...container,
    minHeight: "60px",
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap"
  },
  flex: {
    flex: 1
  },
  title: {
    ...defaultFont,
    lineHeight: "28px",
    fontSize: "18px",
    borderRadius: "8px",
    textTransform: "none",
    color: "inherit",
    padding: "8px 12px",
    letterSpacing: "0.5px",
    fontWeight: 500,
    margin: 0,
    "&:hover,&:focus": {
      color: "inherit",
      background: "rgba(0,0,0,0.03)"
    }
  },
  appResponsive: {
    margin: "20px 12px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px"
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
    boxShadow: "0 4px 16px rgba(156, 39, 176, 0.3)"
  },
  info: {
    backgroundColor: infoColor,
    color: "#FFFFFF",
    boxShadow: "0 4px 16px rgba(0, 188, 212, 0.3)"
  },
  success: {
    backgroundColor: successColor,
    color: "#FFFFFF",
    boxShadow: "0 4px 16px rgba(76, 175, 80, 0.3)"
  },
  warning: {
    backgroundColor: warningColor,
    color: "#FFFFFF",
    boxShadow: "0 4px 16px rgba(255, 152, 0, 0.3)"
  },
  danger: {
    backgroundColor: dangerColor,
    color: "#FFFFFF",
    boxShadow: "0 4px 16px rgba(244, 67, 54, 0.3)"
  },
  rose: {
    backgroundColor: roseColor,
    color: "#FFFFFF",
    boxShadow: "0 4px 16px rgba(233, 30, 99, 0.3)"
  },
  transparent: {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    boxShadow: "none",
    paddingTop: "16px",
    color: modernColors.textPrimary,
    backdropFilter: "blur(8px)"
  },
  dark: {
    color: "#FFFFFF",
    backgroundColor: "#212121",
    boxShadow: "0 4px 16px rgba(33, 33, 33, 0.3)"
  },
  white: {
    border: "0",
    padding: "0",
    marginBottom: "0",
    color: modernColors.textPrimary,
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)"
  },
  header: {
    backgroundColor: headerColor,
    color: colors.Header_Content,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)"
  },
  drawerPaper: {
    border: "none",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: drawerWidth,
    ...boxShadow,
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    right: "0",
    left: "auto",
    visibility: "visible",
    overflowY: "auto",
    borderTop: "none",
    textAlign: "left",
    paddingRight: "0",
    paddingLeft: "0",
    borderRadius: "0 0 0 12px",
    ...transition,
    backgroundColor: modernColors.drawer,
    "&::-webkit-scrollbar": {
      width: "6px",
      backgroundColor: "transparent"
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: "rgba(0,0,0,0.2)"
    }
  }
};

export default headerStyle;
